import { useEffect, useRef } from 'react';
import { BrowserRouter, useLocation, useNavigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { GlobalStyle } from './Globals';
import { themes } from './theme';
import { useStore } from './stores/store';
import { cacheRead } from './api/client';
import { Layout } from './components/Layout';
import { AppRoutes } from './router';
import { Welcome } from './components/Welcome';
import { sessionStart, pageEnter, flush } from './lib/analytics';

// Inicio en "Hoy". Cuando el Mundial termina (remaining 0), el inicio pasa a "Resumen".
function RouteTracker() {
  const loc = useLocation();
  const navigate = useNavigate();
  const started = useRef(false);

  useEffect(() => {
    if (loc.pathname === '/') {
      const t = cacheRead<{ remaining: number }>('/tournament');
      if (t != null && t.remaining === 0) navigate('/resumen', { replace: true });
    }
    started.current = true;
  }, []);

  return null;
}

// Analítica anónima: registra ingreso, páginas visitadas y tiempo en cada una.
function AnalyticsTracker() {
  const loc = useLocation();

  useEffect(() => {
    sessionStart();
    const onVisibility = () => {
      if (document.visibilityState === 'hidden') flush();
    };
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('pagehide', flush);
    return () => {
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('pagehide', flush);
    };
  }, []);

  useEffect(() => {
    pageEnter(loc.pathname);
  }, [loc.pathname]);

  return null;
}

export function App() {
  const themeName = useStore((s) => s.theme);
  return (
    <ThemeProvider theme={themes[themeName]}>
      <GlobalStyle />
      <Welcome />
      <BrowserRouter basename={process.env.PUBLIC_URL || undefined}>
        <RouteTracker />
        <AnalyticsTracker />
        <Layout>
          <AppRoutes />
        </Layout>
      </BrowserRouter>
    </ThemeProvider>
  );
}
